import React from "react";
import { Check, AlertCircle, X } from "./../../Public/assets/index";
import {
  formatCurrency,
  formatChargePurpose,
  getFeeLabel,
  getIcon,
  transactionTypes,
} from "./../../Utils/helperFunction";

const statusTypes = {
  PROCESSING: "PROCESSING",
  IN_APPROVAL: "IN_APPROVAL",
  APPROVAL_RECALLED: "APPROVAL_RECALLED",
  APPROVAL_REJECTED: "APPROVAL_REJECTED",
  APPROVAL_BLOCKED: "APPROVAL_BLOCKED",
  SCHEDULED: "SCHEDULED",
  OVERDUE: "OVERDUE",
  SENT: "SENT",
  PAID: "PAID",
  FAILED: "FAILED",
  CANCELLATION_REQUESTED: "CANCELLATION_REQUESTED",
  CANCELLED: "CANCELLED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
  APPROVED: "APPROVED",
  FUNDED: "FUNDED",
  CLEARING: "CLEARING",
  FULLY_CLEARED: "FULLY_CLEARED",
  PARTIALLY_REVERSED: "PARTIALLY_REVERSED",
  PARTIALLY_CLEARED: "PARTIALLY_CLEARED",
  FULLY_REVERSED: "FULLY_REVERSED",
};

export const TransactionItem = (props) => {
  const getName = () => {
    if (props.transaction_type === transactionTypes.FUND_RECEIVED) {
      return props?.transaction_from_account_desc;
    } else if (props?.transaction_type === transactionTypes.CONVERSION) {
      return "Currency Conversion";
    } else if (props.transaction_type === transactionTypes.TRANSACTION) {
      return props?.transaction_to_account_desc;
    } else if (props.transaction_type === transactionTypes.CHARGE) {
      return (
        formatChargePurpose(props?.transaction_purpose) ||
        props?.transaction_to_account_desc
      );
    } else if (props.transaction_type === transactionTypes.REFUND) {
      return props?.transaction_to_account_desc;
    } else if (props.transaction_type === transactionTypes.FEES) {
      return getFeeLabel(props?.transaction_remarks);
    } else if (props.transaction_type === transactionTypes.CARD_SPEND) {
      return props?.transaction_to_account_desc;
    } else if (props?.transaction_to_account_desc) {
      return props?.transaction_to_account_desc;
    }

    return "--";
  };

  const getTransferMethodText = () => {
    if (props?.transaction_type === "CONVERSION") {
      return `${props?.transaction_from_currency} to ${props?.transaction_to_currency}`;
    } else if (props?.transaction_type === "CARD_SPEND") {
      return "Debit Card";
    } else if (
      props?.transaction_type === "CLEARING" ||
      props?.transaction_type === "PENDING" ||
      props?.transaction_type === "AUTHORIZATION" ||
      props?.transaction_type === "REVERSAL" ||
      props?.transaction_type === "REFUND"
    ) {
      return props?.transaction_type
        .toLowerCase()
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (ch) => ch.toUpperCase());
    } else if (props?.transaction_transfer_method === "LOCAL") {
      return "Borderless Instant";
    } else if (props?.transaction_transfer_method) {
      return props?.transaction_transfer_method;
    } else if (props?.transaction_type === "FUND_RECEIVED") {
      return props?.transaction_from_currency;
    } else if (
      props?.transaction_from_currency === props?.transaction_to_currency
    ) {
      return props?.transaction_to_currency;
    } else {
      return `${props?.transaction_from_currency} to ${props?.transaction_to_currency}`;
    }
  };

  function formatDateToIST(dateString) {
    // Parse the date string
    const date = new Date(dateString);

    // Options for date formatting
    const dateOptions = {
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    };

    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };

    const formattedDate = new Intl.DateTimeFormat("en-GB", dateOptions).format(
      date,
    );
    const formattedTime = new Intl.DateTimeFormat("en-GB", timeOptions).format(
      date,
    );

    return {
      date: formattedDate,
      time: `${formattedTime} IST`,
    };
  }

  const getStatusElement = () => {
    const successfulStatuses = [
      statusTypes?.PAID,
      statusTypes?.COMPLETED,
      statusTypes?.APPROVED,
      statusTypes?.FUNDED,
      statusTypes?.FULLY_CLEARED,
      statusTypes?.PARTIALLY_CLEARED,
      statusTypes?.PARTIALLY_REVERSED,
      statusTypes?.FULLY_REVERSED,
    ];

    const failedStatuses = [
      statusTypes?.APPROVAL_REJECTED,
      statusTypes?.APPROVAL_BLOCKED,
      statusTypes?.FAILED,
      statusTypes?.REJECTED,
      statusTypes?.CANCELLED,
    ];

    const processingStatuses = [
      statusTypes?.PROCESSING,
      statusTypes?.IN_APPROVAL,
      statusTypes?.APPROVAL_RECALLED,
      statusTypes?.SCHEDULED,
      statusTypes?.CANCELLATION_REQUESTED,

      statusTypes?.OVERDUE,
      statusTypes?.SENT,
    ];

    const InitiatedStatus = [statusTypes?.PENDING];

    if (successfulStatuses.includes(props?.transaction_status)) {
      return (
        <span className="text-success flex items-center">
          <img src={Check} alt="Successful" className="mr-1" />
          Successful
        </span>
      );
    }

    if (failedStatuses.includes(props?.transaction_status)) {
      return (
        <span className="text-failed flex items-center">
          <img src={X} alt="Failed" className="mr-1" />
          Failed
        </span>
      );
    }

    if (processingStatuses.includes(props?.transaction_status)) {
      return (
        <span className="text-processing flex items-center">
          <img src={AlertCircle} alt="Processing" className="mr-1" />
          Processing
        </span>
      );
    }
    if (InitiatedStatus.includes(props?.transaction_status)) {
      return (
        <span className="text-processing flex items-center">
          <img src={AlertCircle} alt="Initiated" className="mr-1" />
          Initiated
        </span>
      );
    }

    // Default case
    return <span>--</span>;
  };

  return (
    <div className="flex px-6 py-4 border-b border-gray-200 last:border-b-0">
      <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-4">
        {getIcon({ type: props?.transaction_type })}
      </div>
      <div className="flex-grow">
        <div className="flex justify-between items-start">
          <div className="flex flex-col gap-y-1 md:gap-y-2 min-w-0 flex-1 mr-4">
            <p className="font-normal text-base text-blackShade truncate">
              {getName()}
            </p>
            <>
              {
              props?.transaction_type !== "FEES" && (
                <p className="text-sm text-greyish">
                  {getTransferMethodText()}
                </p>
              )}

              {(props?.transaction_type === "CONVERSION" ||
                props?.transaction_type === "TRANSFER" ||
                props?.transaction_type === "REFUND"
              ) &&
                props?.transaction_forex_rate && (
                  <p className="text-sm text-greyish">
                    1 {props?.transaction_from_currency} ={" "}
                    {props?.transaction_forex_rate}{" "}
                    {props?.transaction_to_currency}
                  </p>
                )}
            </>
          </div>
          <div className="flex flex-col gap-y-1 md:gap-y-2 items-end">
            <p className="font-geomanistBold text-[14px] lg:text-[16px] text-end text-base text-blackShade">
              {props?.transaction_type === "CARD_SPEND" ? (
                <>
                  {props?.transaction_from_currency
                    ? props?.transaction_from_currency
                    : "USD"}{" "}
                  {props?.transaction_debit_amount
                    ? formatCurrency(props?.transaction_debit_amount)
                    : "--"}
                </>
              ) : (
                <>
                  {props?.transaction_to_currency
                    ? props?.transaction_to_currency
                    : "USD"}{" "}
                  {props?.transaction_amount
                    ? formatCurrency(props?.transaction_amount)
                    : "--"}
                </>
              )}
            </p>
            {props?.transaction_created_at ? (
              <div className="text-greyish text-[12px] lg:text-[14px] text-end flex">
                <p className="leading-tight">
                  {formatDateToIST(props?.transaction_created_at).date},
                </p>
                <p className="leading-tight">
                  {formatDateToIST(props?.transaction_created_at).time}
                </p>
              </div>
            ) : (
              <p className="text-greyish text-[12px] lg:text-[14px]">--</p>
            )}
            <div className="border border-[#D0D5DD] rounded-[8px] px-3 py-1 mt-1">
              {getStatusElement()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
